import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'uicEstado'
})
export class UicEstadoPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) { }

  transform(value: unknown): SafeHtml {
    let label = '';
    let cssClass = '';
    let icon = '';
    let strong = false;

    // 1- No existe, 2- Recogiendo, 3- Completado, 8 Incidencia
    switch (value) {
      case '1':
        label = 'No existe';
        cssClass = 'badge-estado-muted';
        break;
      case '2':
        label = 'Recogiendo';
        cssClass = 'badge-estado-info';
        break;
      case '3':
        label = 'Completado';
        cssClass = 'badge-estado-success';
        strong = true;
        break;
      case '8':
        label = 'Incidencia';
        cssClass = 'badge-estado-danger';
        break;
      default:
        return this.sanitizer.bypassSecurityTrustHtml(String(value));
    }

    // Construir HTML final
    const text = strong ? `<strong>${label}</strong>` : label;
    const html = `<span class="badge ${cssClass}">${icon} ${text}</span>`;

    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

}